import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface AbApiResponse {
    [key: string]: string
}

export const abApi = createApi({
    reducerPath: 'abApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: (headers, api) => {
            return setCommonHeaders(headers)
        }
    }),

    tagTypes: ['abApi'],
    endpoints: builder => ({
        getAbApiData: builder.query<AbApiResponse, void>({
            query: () => '/source/abtest/getflyinpwaconfig',
            providesTags: (result, error) => [{ type: 'abApi' }]
        })
    })
})

export const { useGetAbApiDataQuery } = abApi

export default abApi
